import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { APP_PATHS } from '../constants/app-routes';
import { isStaffRole } from '../constants/roles';
import { AuthService } from '../services/auth.service';

export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.getToken()) {
    return router.createUrlTree([APP_PATHS.login]);
  }

  const current = auth.user();
  if (isStaffRole(current?.role)) {
    return true;
  }

  return auth.loadProfile().pipe(
    map((user) => {
      if (isStaffRole(user?.role)) {
        return true;
      }
      return router.createUrlTree([APP_PATHS.myRoute]);
    })
  );
};
